import { render } from "./DropCardActions.vue?vue&type=template&id=574f8ccc&scoped=true"
import script from "./DropCardActions.vue?vue&type=script&lang=js"
export * from "./DropCardActions.vue?vue&type=script&lang=js"

import "./DropCardActions.vue?vue&type=style&index=0&id=574f8ccc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-574f8ccc"

export default script